import React from 'react';
import { StaysListingDetail } from '../../dashboard/dashboard-stays-components/stays-listing-detail';
import type { StaysListingSection } from './stays-listing-routes';

/**
 * ONE STAYS LISTING, WITH ITS SECTIONS (ai-plans/stays plan S4, the listing
 * shell): /dashboard/stays/<id>[/overview|/stays[/<reservation id>]|/calendar|/new].
 *
 * A REFACTOR, NOT A NEW PAGE. Plan S1's StaysListingDetail already loads the
 * listing, owns its header ("Back to Stays", the title, the pills, "Open
 * unit") and its S1/S3 content; in shell mode it adds "New stay", the tab
 * strip and the section. The Overview keeps S1/S3's DOM, and the bare path
 * renders it — S1/S3 journeys open /dashboard/stays/<id> and expect S1's
 * content there, so there is no redirect to /overview.
 *
 * The path, the tabs and their APPEND CONTRACT live in stays-listing-routes.ts
 * (StaysListingDetail imports them; defining them here would make the two files
 * import each other) and are re-exported from here. A later plan's tab is ONE
 * appended STAYS_LISTING_TABS entry, its segment in STAYS_LISTING_PATH's section
 * alternation, and its case in StaysListingDetail's sectionBody.
 *
 * Rendered by dashboard.tsx inside the dashboard's single <main>; the page's
 * one h1 is the dashboard heading, the listing name is an h2.
 */

export {
  STAYS_LISTING_PATH,
  STAYS_LISTING_TABS,
  guideTabHref,
  guideTabOf,
  headOf,
  listingSectionHref,
  sectionOf,
  stayHref,
} from './stays-listing-routes';
export type { GuideEditorTab, StaysListingSection, StaysListingTab } from './stays-listing-routes';

export interface StaysListingShellProps {
  listingId: string;
  section: StaysListingSection;
  /** Section 'stays' only: the stay whose edit modal opens over the table. */
  reservationId?: string | null;
}

export const StaysListingShell: React.FC<StaysListingShellProps> = ({ listingId, section, reservationId = null }) => (
  <StaysListingDetail
    listingId={listingId}
    section={section}
    reservationId={section === 'stays' ? reservationId : null}
  />
);
